/*eslint-env jquery*/
import React from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { MemberNavMenu } from './MemberNavMenu'
import appVersion from '../../../_constants/appVersion'
import { Link } from 'react-router-dom'
import { config } from '../../../config'
import Header from './header'


import '../../../assets/css/material-dashboard.css'

// import '@mdi/font/css/materialdesignicons.min.css'
// import '../../../assets/css/leaflet.css'
import '../../../assets/css/indicator.css'
import '../../../assets/css/main.scss'

import "imrc-datetime-picker/dist/imrc-datetime-picker.css"

class MemberLayout extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      toggled: false
    };

  }

  toggle = () => {


    var toggled = !this.state.toggled;
    this.setState({ toggled: toggled })

    if (!toggled) {
      $('html').removeClass('nav-open')
    } else {
      $('html').addClass('nav-open')
    }

  }

  toggleOff = () => {

    this.setState({ toggled: false })

    $('html').removeClass('nav-open')

  }

  componentDidMount() {

    // ReactDOM.findDOMNode().getElementsByClassName('nav-item').addEventListener('click', this.toggle)
    document.body.addEventListener('click', this.toggleOff)
  }
  //   var mobile_menu_visible = 0;

  //   $(document).on('click', '.navbar-toggle', function () {

  //     var $toggle = $(this);

  //     if (mobile_menu_visible == 1) {
  //       $('html').removeClass('nav-open');

  //       $('.close-layer').remove();
  //       setTimeout(function () {
  //         $toggle.removeClass('toggled');
  //       }, 400);

  //       mobile_menu_visible = 0;
  //     } else {
  //       setTimeout(function () {
  //         $toggle.addClass('toggled');
  //       }, 430);

  //       var $layer = $('<div className="close-layer"></div>');

  //       if ($('body').find('.main-panel').length != 0) {
  //         $layer.appendTo(".main-panel");

  //       } else if (($('body').hasClass('off-canvas-sidebar'))) {
  //         $layer.appendTo(".wrapper-full-page");
  //       }

  //       setTimeout(function () {
  //         $layer.addClass('visible');
  //       }, 100);

  //       $layer.click(function () {
  //         $('html').removeClass('nav-open');
  //         mobile_menu_visible = 0;

  //         $layer.removeClass('visible');

  //         setTimeout(function () {
  //           $layer.remove();
  //           $toggle.removeClass('toggled');

  //         }, 400);
  //       });

  //       $('html').addClass('nav-open');
  //       mobile_menu_visible = 1;

  //     }

  //   });

  // }

  // componentDidMount(){
  //   $(function(){
  //     $(".fa").bind('input propertychange',function(){
  //          if(!/^[پچجحخهعغفقثصضشسیبلاتنمکگوئدذرزطظژؤإأءًٌٍَُِّ\s\n\r\t\d\(\)\[\]\{\}.,،;\-؛]+$/.test($(this).val())){
  //              alert("فقط حروف فارسی مورد قبول است");
  //             $(this).val("");
  //          }
  //     });
  //     $(".email, .englishInput").bind('input propertychange',function(){
  //          if(/^[پچجحخهعغفقثصضشسیبلاتنمکگوئدذرزطظژؤإأءًٌٍَُِّ]+$/.test($(this).val())){
  //              alert("وارد کردن حروف فارسی برای این فیلد مجاز نیست");
  //             $(this).val("");
  //          }
  //     });
  //   });
  //   }

  render() {
    const { toggled } = this.state;
    const { user } = this.props;
    return (
      <div>
        <Header />
        <div className="wrapper" data-turbolinks="false">
          <div className="sidebar" data-active-color="orange" data-background-color="black">
            <div className="logo">
              <div className="dashboard-logo">
                <img src="/admin/images/logo.png" alt="" />
              </div>
            </div>
            <div className="sidebar-wrapper" id="style-6">
              <MemberNavMenu />
            </div>
            <div className="version-info numberFa">نسخه {appVersion.slice(-1)[0].version}
              <span className="numberFa">تاریخ به روزرسانی {appVersion.slice(-1)[0].date}</span>
            </div>
          </div>
          <div className="main-panel" id="content">
            <div className={toggled ? "close-layer visible" : "close-layer hidden"} onClick={() => this.toggleOff()}></div>
            <nav className="navbar navbar-absolute"
              style={{ boxShadow: "rgba(0, 0, 0, 0.1) 0px 0px 9px 1px, rgba(0, 0, 0, 0.1) 0px -5px 2px 2px" }}>
              <div className="container-fluid">


                <div className="navbar-wrapper">

                  <div className="navbar-header pull-right">
                    <button type="button" className={toggled ? "navbar-toggle toggled" : "navbar-toggle"} data-toggle="collapse" onClick={() => this.toggle()}>
                      <span className="sr-only">Toggle navigation</span>
                      <span className="icon-bar"></span>
                      <span className="icon-bar"></span>
                      <span className="icon-bar"></span>
                    </button>
                  </div>

                  <div className="navbar-header pull-right header-icons avatar-container">
                    {user && user.logo ?
                      <img className="avatar" src={config.uploadsUrl + user.logo} alt="" />
                      :
                      <img className="avatar" src="/admin/images/default-avatar.png" alt="" />
                    }
                    <div className="names">
                      {user && user.firstName && user.lastName && <span>{user.firstName + ' ' + user.lastName}</span>}
                      {user && user.unionName && <span>عضو محترم {user.unionName}</span>}
                    </div>
                  </div>
                  <div className="pull-left" style={{ padding: "10px 30px 0 0" }}>
                    <Link to="/login" ><i className="mdi mdi-power mdi-36px"></i></Link>
                  </div>

                  <div className="pull-left">

                  </div>

                </div>
              </div>
            </nav>
            <div className="content">
              <div className="container-fluid">

                {this.props.children}

              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { authentication } = state;
  const { user } = authentication;
  // console.log(user);

  return {
    user
  };
}

$(document).on('click', 'body ', function (e) {
  // console.log(e);

  // e.stopPropagation();
  $(this).find('.classSelect').removeClass('active');

});

const connectedMemberLayout = connect(mapStateToProps)(MemberLayout);
export { connectedMemberLayout as MemberLayout };

